import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-more',
  templateUrl: './more.component.html',
  styleUrls: ['./more.component.scss'],
})
export class MoreComponent implements OnInit {
  items = [
    {text:"Foros"}
  ];
  constructor(
    private popoverController:PopoverController,
    private router:Router
  ) { }

  ngOnInit() {}

  foros(){
    this.router.navigate(["/forum"]);
  }
  moreOption(valor:number){
    switch(valor){
      case 0:
        this.foros();
        break;
    }
    this.popoverController.dismiss();
  }

}
